import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { AppMenuListItem } from "../app-menu-list/AppMenuListItem";
import * as Styled from "./AppNavListItem.styled";
export const AppNavListItem = forwardRef((props, ref) => {
    const { children, href, icon, isActive = false, isOverflowed = false, setIsOpen = () => { }, label, onClick = () => { }, priority, ...otherProps } = props;
    // Being display in an CollapseOverflow popper menu, return AppNavListItem instead of AppMenuListItem
    if (isOverflowed) {
        return (_jsxs(AppMenuListItem, { isActive: isActive, children: [typeof children === "function" ? children(props) : children, !children && label ? (_jsxs("a", { href: href, onClick: (e) => {
                        if (href) {
                            onClick && onClick(e, label);
                        }
                        else {
                            e.preventDefault();
                            onClick(e, label);
                        }
                        setIsOpen(false);
                    }, "aria-current": isActive && "page", children: [icon && icon, label] })) : ("")] }));
    }
    return (_jsxs(Styled.AppNavListItem, { "data-testid": "AppNavListItem", ref: ref, ...otherProps, isActive: isActive, priority: priority, "data-is-active": isActive ? "true" : undefined, ...otherProps, children: [typeof children === "function" ? children(props) : children, !children && label ? (_jsxs("a", { href: href, "aria-current": isActive ? "page" : undefined, onClick: (e) => {
                    if (href) {
                        onClick && onClick(e, label);
                    }
                    else {
                        e.preventDefault();
                        onClick(e, label);
                    }
                }, children: [icon && icon, label] })) : ("")] }));
});
AppNavListItem.defaultProps = {
    priority: "primary"
};
AppNavListItem.displayName = "AppNavListItem";
